// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (exceptions-edit e exceptions-list)

import { Injectable } from '@angular/core';
import { Exceptions } from './exceptions.model';
import { Subject } from 'rxjs';

@Injectable()
export class ExceptionsService {
  private exceptions: Exceptions[] = [];
  exceptionsChanged = new Subject<Exceptions[]>();
  exceptionsEditMode = new Subject<number>();

  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editExceptions(exceptionsId: number) {
    this.exceptionsEditMode.next(exceptionsId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setExceptions(exceptions: Exceptions[]) {
    if (exceptions !== null) {
      this.exceptions = exceptions;
      this.exceptionsChanged.next(this.exceptions.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getExceptionsByIndex(id: number) {
    return this.exceptions.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getExceptions() {
    return this.exceptions;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addExceptions(exceptions: Exceptions) {
    exceptions.id = this.exceptions.length;
    this.exceptions.push(exceptions);
    this.exceptionsChanged.next(this.exceptions.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateExceptions(index: number, exceptions: Exceptions) {
    this.exceptions[index] = exceptions;
    this.exceptionsChanged.next(this.exceptions.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteExceptions(id) {
    var elementPos = this.exceptions.map(function (x) { return x.id; }).indexOf(id);
    this.exceptions.splice(elementPos, 1);
    this.exceptionsChanged.next(this.exceptions.slice());
  }
}
